import { ProductFamily } from "@custom-types/products"
import { useCallback, useEffect } from "react"
import { useLazyGetFamilyBasesQuery } from "@store/services/baseGraphFamiliesService"
import { Box, CircularProgress, IconButton } from "@mui/material"
import { Table } from "@components/Table"
import { getGraphsColumns } from "@features/administration/products/EditProduct/const"
import { MRT_Row } from "material-react-table"
import EditIcon from "@mui/icons-material/Edit"
import { GraphDto } from "@custom-types/graphs"
import { useNavigate } from "react-router"

type GraphsTableProps = {
  productFamily: ProductFamily
}

export function GraphsTable(props: GraphsTableProps) {
  const [fetchBases, { data, isFetching }] = useLazyGetFamilyBasesQuery()
  const navigate = useNavigate()
  useEffect(() => {
    if (props.productFamily) {
      fetchBases({ familyKey: props.productFamily.key, roleHint: "None" })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  }, [props.productFamily])

  const columns = getGraphsColumns()

  const getRowActions = useCallback(
    ({ row }: { row: MRT_Row<GraphDto> }) => (
      <Box sx={{ display: "flex", gap: "4px" }}>
        <IconButton
          onClick={() =>
            navigate(`/Administration/BaseGraphs/${encodeURIComponent(row.original.key)}`)
          }
        >
          <EditIcon />
        </IconButton>
      </Box>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
    [],
  )

  return (
    <>
      {isFetching ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Table
          data={data || []}
          columns={columns}
          enableExpandAll={false}
          enableRowActions={true}
          getRowId={(row) => row.key}
          muiTablePaperProps={{ sx: { overflow: "scroll" } }}
          sessionStorageName={"graphs-table"}
          renderRowActions={getRowActions}
        />
      )}
    </>
  )
}
